<p>
    This is a touch based 2D tower defense prototype I built for a client. In
    it, the player can switch between heroes, who each have 3 unique abilities
    which affect the battlefield.
</p>

<p>
    The player defends their base, which has limited health, on the right side.
    Various enemy types spawn in and attack from the left. The player can also
    find, store, and equip potions in their backpack.
</p>
